import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseApiUrls, UnAuthenticatedDataPost } from './ApiHelpers';

export const autoRegister = ({ env, payload }) => {
  const apiUrl = `${BaseApiUrls[env]}api/customer/autoRegister`;

  return UnAuthenticatedDataPost({
    apiUrl,
    payload
  });
};

export const signInApi = createApi({
  reducerPath: 'signInApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BaseApiUrls.middlewareApiUrl
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (data) => ({
        url: '/api/customer/signin',
        method: 'POST',
        body: data
      }),
      // onSuccess callback to dispatch actions
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const response = await queryFulfilled; // Wait for the response
        // Store the token in localStorage
        if (response.data) {
          localStorage.setItem('authentication', JSON.stringify(response.data));
        }
      }
    })
  })
});

export const { useSignInMutation } = signInApi;
